import { PRIMARY_KEY } from '@/utils/constants';
import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
export default function RequestLoader({ color = PRIMARY_KEY }: { color?: string }) {
	return (
		<section className={'data-loading-container'}>
			<PulseLoader color={color} />
		</section>
	);
}
